const result = [15000, 43400];

export default result;
